import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fileUrl = (path) =>
  path ? `${API}/files/${path}` : null;

/**
 * Resolve a media URL from anywhere in the backend into an absolute HTTPS
 * URL the browser (and, critically, the Capacitor WebView) can actually
 * load.
 *
 * The Android WebView loads assets from `capacitor://localhost/`, so any
 * relative path — including the `/api/files/...` values stored by the
 * backend for avatars and portraits — resolves to a bogus
 * `capacitor://localhost/api/files/...` URL and returns 404. That's the
 * root cause of every "broken avatar / AI portrait" bug on the APK.
 *
 * Accepts:
 *   • null / undefined → returns null
 *   • absolute http(s) URL (e.g. Google profile pic) → returned as-is
 *   • `/api/files/...` (backend-relative)                → prefixed with BACKEND_URL
 *   • bare storage path like `stylio/avatars/xxx.png`    → wrapped via fileUrl()
 */
export const resolveMediaUrl = (u) => {
  if (!u) return null;
  if (/^(https?:|data:|blob:)/i.test(u)) return u;
  if (u.startsWith("/api/")) return `${BACKEND_URL}${u}`;
  if (u.startsWith("/")) return `${BACKEND_URL}${u}`;
  // Otherwise treat it as a storage path.
  return fileUrl(u);
};
